export default "__VITE_ASSET__Dis4_cP2__"